module.exports = __webpack_public_path__ + "img/trial3-4.f8724322.png";